module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter01"
    }
  }), _vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sometimes, truth is sufficiently stranger than fiction that it becomes hard to believe. I would like to note that the IRA bombing campaign of 1939 is historical, and so is the case of the German bomb accidentally dropped in Dublin. In some other cases I’ve started from truth and moved it towards plausibility, because this isn’t the real world, thank goodness. Generally I have as far as possible used real names of people who don’t have speaking parts in the narrative, like Winston Churchill, but fictionalized names and lives of those who do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thanks to my LiveJournal correspondents for coming up with fast answers to odd questions, particularly Tim Illingworth and David Dyer-Bennet, and for cheering me on while I was writing this ("), _c('a', {
    attrs: {
      "href": "http://papersky.livejournal.com",
      "target": "_blank"
    }
  }, [_vm._v("papersky.livejournal.com")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thanks to Lis Riba for asking a useful question, to Emmet O’Brien for diligently checking my Hiberno-English, to Patrick Nielsen Hayden for taking time out on a busy morning to be helpful and for always being a great editor, to Mary Lace for reading this as fast as it was being written and making helpful suggestions, to the production people at Tor for doing a really good job on all my books so far, to Janet Kegg for finding and sending me Anne de Courcy’s "), _c('em', [_vm._v("1939: The Last Season")]), _vm._v(", to Sarah Monette for alerting me to the existence of "), _c('em', [_vm._v("Five and Eighty Hamlets")]), _vm._v(", without which I’d probably never have thought of this story, and to Sherwood Smith, Laura Tennenhouse, David Goldfarb, Madeline "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("Kelly, David Dyer-Bennet, Jennifer Arnott, and Janet Kegg for beta-reading.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I’d also like to thank the late W. T. Roberts of Ynys-y-Bwl for keeping every program from every performance of every theatrical event he went to throughout his long life, and Mary Lace for giving me access to the ones from the era covered in this novel. They contain marvels nobody could make up and are like a whiff of the real theater world of the time. I’m glad to say they are now collected in the University of Leicester for the benefit of anyone else who wants to use them.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-209422b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 69
// module chunks = 0